import { render, staticRenderFns } from "./Advertisments.vue?vue&type=template&id=2fa4a25a&scoped=true&"
import script from "./Advertisments.vue?vue&type=script&lang=js&"
export * from "./Advertisments.vue?vue&type=script&lang=js&"
import style0 from "./Advertisments.vue?vue&type=style&index=0&id=2fa4a25a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa4a25a",
  null
  
)

export default component.exports